import styled from "styled-components";

export const FooterParent = styled.div`
  /* height: 40px; */
  /* bottom: 0; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
  /* background: #3ea7ec; */
  /* color: #fff; */
`;
